<template>
  <div @click="ytVideo" class="clip">
    <video
      class="video"
      src="@/assets/videos/sizzle2.mp4"
      loop
      muted
      autoplay
    ></video>
    <div class="fullscreen">
      <img src="@/assets/images/youtube/fullscreen.png" alt="" />
    </div>
    <div class="text-balken">Trailer 2 ansehen</div>
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js'

export default {
  methods: {
    ytVideo() {
      EventBus.$emit('open-yt-2')
    },
  },
}
</script>

<style lang="scss" scoped>
.clip {
  cursor: pointer;
  position: relative;
  max-width: 2560px;
  width: 100%;
  &:hover {
    opacity: 0.8;
  }
  .video {
    width: 100%;
  }
  .fullscreen {
    position: absolute;
    top: 30px;
    right: 30px;
  }
  .text-balken {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 20px;
    color: white;
    font-size: 1.6rem;
    font-weight: 900;
    text-transform: uppercase;
    background-color: var(--clr-red);
    padding-inline: 1em;
    padding-block: 0.2em;
  }
}
</style>
